import { makeApiTypes } from 'sidecar-utility-library'
import reduceReducers from 'reduce-reducers'

import { default as authReducer } from './auth'

export * from './auth'

export const types = {
  ...makeApiTypes('LOGIN', 'auth'),
  ...makeApiTypes('LOGOUT', 'auth'),
  ...makeApiTypes('FETCH_LOGIN_HISTORY', 'auth'),
  ...makeApiTypes('CONTACT_US', 'auth'),
  FORCE_AUTH: 'auth/FORCE_AUTH',
  FORCE_LOGOUT: 'auth/FORCE_LOGOUT',
  FLUSH_AUTH_ERRORS: 'auth/FLUSH_AUTH_ERRORS',
  LOGIN_FROM_LOCAL: 'auth/LOGIN_FROM_LOCAL',
  STORE_AUTHED_USER: 'auth/STORE_AUTHED_USER',
  CLEAR_AUTHED_USER: 'auth/CLEAR_AUTHED_USER',
  CLEAR_ERROR_MESSAGE: 'auth/CLEAR_ERROR_MESSAGE',
}

export const initialState = {
  busy: false,
  error: '',
  loginHistory: [],
  authToken: null,
  authedUser: {},
  accountMemberAccessMap: {},
  isAuthAttempted: false,
}

export default reduceReducers(authReducer)
